import { render, staticRenderFns } from "./PrgTreeTable.vue?vue&type=template&id=f01179da&"
import script from "./PrgTreeTable.vue?vue&type=script&lang=ts&"
export * from "./PrgTreeTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports